<template>
  <div class="sidesheet">
    <div style="margin: 15px;">
      <h2><i class="fa fa-fw fa-sort-amount-desc"></i> Map Filters</h2>

      <h3>Show</h3>

      <div class="form-group-outer">

        <div class="form-group">
          <div class="checkbox checkbox-primary">
            <input id="check-show-jobs" class="styled" type="checkbox" checked="" v-model="showJobs"/>
            <label for="check-show-jobs">
              Jobs
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox checkbox-primary">
            <input id="check-show-requests" class="styled" type="checkbox" checked="" v-model="showRequests"/>
            <label for="check-show-requests">
              Requests
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox checkbox-primary">
            <input id="check-show-active-trucks" class="styled" type="checkbox" checked="" v-model="showActiveTrucks"/>
            <label for="check-show-active-trucks">
              Active Trucks
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox checkbox-primary">
            <input id="check-show-inactive-trucks" class="styled" type="checkbox" checked=""
                   v-model="showInactiveTrucks"/>
            <label for="check-show-inactive-trucks">
              Inactive trucks
            </label>
          </div>
        </div>

      </div><!-- /.form-group-outer -->

      <h3>Filter Results</h3>

      <div class="form-group">
        <label class="control-label">Jobs and Clients</label>
        <selectize
          class="select2-material"
          v-model="filterJobs"
          name="trucks"
          :options="jobOptions"
          valueField="text"
          multiple
        >
        </selectize>
      </div><!-- /.form-group -->

      <div class="form-group">
        <label class="control-label">Trucks</label>
        <selectize
          class="select2-material"
          v-model="filterTrucks"
          name="trucks"
          :options="truckOptions"
          valueField="text"
          multiple
        >
        </selectize>
      </div><!-- /.form-group -->

      <div class="form-group">
        <label class="control-label">Carriers</label>
        <selectize
          class="select2-material"
          v-model="filterCarriers"
          name="trucks"
          :options="carrierOptions"
          valueField="text"
          multiple
        >
        </selectize>
      </div><!-- /.form-group -->

      <div class="text-right">
        <button type="button" class="btn btn-default" @click="clearFilters">
          <i class="fa fa-ban"></i> Clear Filters
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { Selectize } from 'components/forms'

export default {
  components: {
    Selectize
  },

  props: {
    value: {
      required: true,
      type: Object
    },
    jobs: {
      required: true,
      type: Array
    },
    drivers: {
      required: true,
      type: Array
    }
  },

  computed: {
    showJobs: {
      get () {
        return this.value.show.jobs
      },
      set (value) {
        this.$emit('input', { ...this.value, show: { ...this.value.show, jobs: value } })
      }
    },

    showRequests: {
      get () {
        return this.value.show.requests
      },
      set (value) {
        this.$emit('input', { ...this.value, show: { ...this.value.show, requests: value } })
      }
    },

    showActiveTrucks: {
      get () {
        return this.value.show.activeTrucks
      },
      set (value) {
        this.$emit('input', { ...this.value, show: { ...this.value.show, activeTrucks: value } })
      }
    },

    showInactiveTrucks: {
      get () {
        return this.value.show.inactiveTrucks
      },
      set (value) {
        this.$emit('input', { ...this.value, show: { ...this.value.show, inactiveTrucks: value } })
      }
    },

    filterCarriers: {
      get () {
        return this.value.carriers
      },
      set (value) {
        this.$emit('input', { ...this.value, carriers: value })
      }
    },

    filterJobs: {
      get () {
        return this.value.jobs
      },
      set (value) {
        this.$emit('input', { ...this.value, jobs: value })
      }
    },

    filterTrucks: {
      get () {
        return this.value.trucks
      },
      set (value) {
        this.$emit('input', { ...this.value, trucks: value })
      }
    },

    truckOptions () {
      const trucks = new Set()
      this.drivers.forEach((driver) => {
        driver.trucks.forEach((truck) => {
          trucks.add({ id: truck.id, text: truck.registration })
        })
      })
      return [...trucks]
    },

    carrierOptions () {
      const carriers = new Set()
      this.drivers.forEach((driver) => {
        driver.carriers.forEach((carrier) => {
          carriers.add({ id: carrier.id, text: carrier.company })
        })
      })

      return [...carriers]
    },

    jobOptions () {
      let jobs = this.jobs.map((job) => {
        return { id: `job-${job.id}`, text: job.number }
      })
      jobs = jobs.concat(this.jobs.map((job) => {
        return { id: `client-${job.client.id}`, text: job.client.company }
      }))

      return [...new Set(jobs)]
    }
  },

  methods: {
    clearFilters () {
      this.$emit('input', { ...this.value, carriers: [], trucks: [], jobs: [] })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Filters.vue?79381dc8